import { syncLessons } from '../../../api/studioIntegrationConfigsApi'
import { getStudiosSuggestion } from '../../../api/studiosApi'
import { getOptions } from '../../../helpers/utils'
import translate from '../../../i18n'
import DebounceSelect from '../../debounce-select/debounce-select'
import { Button, DatePicker, Form, Modal, notification } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'

interface IProps {
  visible: boolean
  onCancel: () => void
  onSubmit: () => void
}

const StudioIntegrationSyncLessonModal = (props: IProps) => {
  const { visible, onCancel, onSubmit } = props
  const [loading, setLoading] = useState<boolean>(false)

  const [form] = Form.useForm()

  const onFinish = (value: { studioId: number; startDate: string; endDate: string }) => {
    setLoading(true)
    syncLessons(
      value.studioId,
      dayjs(value.startDate).toISOString(),
      dayjs(value.endDate).toISOString(),
    )
      .then(() => {
        notification.success({
          message: translate('studioIntegrationConfig.syncLessons'),
          description: translate('studioIntegrationConfig.syncLessons.success'),
        })
        onSubmit()
      })
      .catch(err => {
        notification.error({
          message: translate('studioIntegrationConfig.syncLessons'),
          description:
            err?.error_message || translate('studioIntegrationConfig.syncLessons.failed'),
        })
      })
      .finally(() => {
        setLoading(false)
        onCancel()
      })
  }

  async function fetchStudioList(keyword: string): Promise<{ label: string; value: number }[]> {
    return getStudiosSuggestion(keyword).then(res => {
      return getOptions(res)
    })
  }

  return (
    <Modal
      centered
      open={visible}
      footer={null}
      width={800}
      forceRender
      title={translate('studioIntegrationConfig.syncLessons')}
      onCancel={onCancel}
    >
      <Form
        layout="vertical"
        name="studio-integration-sync-lesson-description-modal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 10 }}
        onFinish={onFinish}
        autoComplete="off"
        form={form}
      >
        <Form.Item
          name="studioId"
          label={translate('studioIntegrationConfig.studioId')}
          rules={[{ required: true }]}
        >
          <DebounceSelect
            style={{ minWidth: 130 }}
            showSearch
            allowClear
            placeholder={translate('studioIntegrationConfig.studioId.message')}
            fetchOptions={fetchStudioList}
          />
        </Form.Item>
        <Form.Item
          name="startDate"
          label={translate('studioIntegrationConfig.startDate')}
          rules={[{ required: true }]}
        >
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item
          name="endDate"
          label={translate('studioIntegrationConfig.endDate')}
          rules={[{ required: true }]}
        >
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {translate('submit')}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default StudioIntegrationSyncLessonModal
